import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/core/shared-services/common.service';
import { SnackbarService } from 'src/app/core/shared-services/snackbar.service';
import { CommonModule,  NgClass, NgIf  } from '@angular/common';
import { IconsModule as FeatherIconsModule } from '../../../modules/shared/icons/icons.module';

@Component({
    selector: 'app-snackbar',
    templateUrl: './snackbar.component.html',
    styleUrls: ['./snackbar.component.scss'],
    standalone: true,
    imports: [CommonModule,
        NgClass,
        NgIf,
        FeatherIconsModule,
    ],
})
export class SnackbarComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    public snackbarService: SnackbarService,
    public router: Router,
    public commonService: CommonService
  ) { }

  ngOnInit(): void {

  }

  linkToModule() {
    if (this.data.buttonText === 'Refresh Reviews') {
      this.snackbarService.acionButtonListener(true);
    }
  }
}

